<div class="container">
  <fgbcl-marketplace-list
    [isList]="true"
    [showSortBar]="false"
    [marketplaceItemTypes]="[3, 5]"
    [eventItemView]="true"
    [defaultSort]="2"
  ></fgbcl-marketplace-list>
</div>
